import axiosCallCenter from "./axios.callcenter";

export type TwilioTokenResponse = {
  /** Twilio identity the token is minted for (agent-side). */
  identity: string;
  /** JWT access token handed to the Twilio `Device`. */
  token: string;
  /**
   * Session that binds this call to the lead's lifecycle on the backend.
   * Passed straight to `device.connect({ params: { sessionName } })` so the
   * post-dial status callback can route WS events to the lead's portal.
   */
  sessionName: string;
};

/**
 * Mints a Twilio Voice access token scoped to a specific lead.
 *
 * The token is no longer agent-generic: the backend resolves/creates the
 * lead's call session from `leadId` and returns the `sessionName` we hand to
 * `device.connect()`. Because the token now depends on a lead, the Device can
 * only be created at call-initiation time (see twilio.context.tsx's lazy
 * connect flow), never at provider mount.
 */
export async function fetchTwilioAccessToken(
  leadId: number,
  callCenterId?: number,
): Promise<TwilioTokenResponse> {
  const { data } = await axiosCallCenter.post<TwilioTokenResponse>(
    "/voice/token",
    { leadId, callCenterId },
  );
  return data;
}
